import { premiumBuildingsPrices } from "@/config/constants";
import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class RangersBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.RANGERS;

	public static readonly baseGemsPrice =
		premiumBuildingsPrices[this.frameName];
}

export default RangersBuildingTileEntity;
